export default "__VITE_ASSET__GEAeH1M4__"